import MEICMonitor from './meic/MEICMonitor';
import TradeSignalsSection from './TradeSignalsSection';

import MeicWebsocketClient from '../Clients/MEICclient';
import StrategyDashboardClient from '../Clients/StrategyDashboardClient';
import StreamingWebsocketClient from '../Clients/StreamingWebsocketClient';
import MarketStructureAnalysisClient from '../Clients/MarketStructureAnalysisClient';


import PositionMonitorStack from './PositionMonitorStack';
import MarketStructureWidget from './MarketStructureWidget';
import CommandStatusStrip from './CommandStatusStrip';

export default function CommandCenter() {
  return (
    <>
      <MeicWebsocketClient />
      <StrategyDashboardClient />
      <StreamingWebsocketClient />
      <MarketStructureAnalysisClient />

      <div className="commandCenterPage">
        <CommandStatusStrip />

        <div className="dashboardGrid">
          {/* ================= LEFT MAIN STACK ================= */}
          <div className="commandMainStack">
            <TradeSignalsSection />

            {/*
              Original Market Snapshot slot.
              Keep this commented for future chart/tab reuse.

              <section className="panel marketSnapshotPanel">
                <MarketSnapshot compact />
              </section>
            */}

            <section className="panel marketSnapshotPanel">
              <MEICMonitor />
            </section>
          </div>

          {/* ================= RIGHT DASHBOARD RAIL ================= */}
          <aside className="rightDashboardRail">
            <PositionMonitorStack />
            <MarketStructureWidget />
          </aside>
        </div>
      </div>
    </>
  );
}



// Include the chart for the market snapshot section
// import MarketSnapshot from './MarketSnapshot';
// import MEICMonitor from './meic/MEICMonitor';
// import TradeSignalsSection from './TradeSignalsSection';
// import MeicWebsocketClient from '../Clients/MEICclient';
// import StrategyDashboardClient from '../Clients/StrategyDashboardClient';
// import PositionMonitorStack from './PositionMonitorStack';
// import MarketStructureWidget from './MarketStructureWidget';
//
// export default function CommandCenter() {
//   return (
//     <>
//       <MeicWebsocketClient />
//       <StrategyDashboardClient />
//
//       <div className="commandCenterPage">
//         {/* ================= TOP KPI STRIP ================= */}
//         <section className="commandStatusStrip">
//           <div className="statusTile">
//             <span>Next Signal</span>
//             <strong>GEMIC / ACCE</strong>
//             <small>3:55 PM ET</small>
//           </div>
//
//           <div className="statusTile">
//             <span>Active Positions</span>
//             <strong>3</strong>
//             <small>Across MEIC + ARGOS</small>
//           </div>
//
//           <div className="statusTile">
//             <span>Closed Today</span>
//             <strong className="positive">+$1,226</strong>
//             <small>3 realized exits</small>
//           </div>
//
//           <div className="statusTile">
//             <span>Market State</span>
//             <strong>Regime 1</strong>
//             <small>Positive GEX / Rising Vol</small>
//           </div>
//         </section>
//
//         <div className="dashboardGrid">
//           {/* ================= LEFT MAIN STACK ================= */}
//           <div className="commandMainStack">
//             <TradeSignalsSection />
//
//             <section className="panel marketSnapshotPanel">
//               <MarketSnapshot compact />
//             </section>
//           </div>
//
//           {/* ================= RIGHT DASHBOARD RAIL ================= */}
//           <aside className="rightDashboardRail">
//             <PositionMonitorStack />
//             <MarketStructureWidget />
//           </aside>
//
//           {/* ================= MEIC BOTTOM MONITOR ================= */}
//           <MEICMonitor />
//         </div>
//       </div>
//     </>
//   );
// }